import React from 'react';
import { useLocation } from 'react-router-dom';

const VideoTour = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const videoKey = queryParams.get('video');

  const videoMap = {
    goldenbear: 'https://my.matterport.com/show/?m=nDk7FW7rw7M',
    cubtrce: 'https://my.matterport.com/show/?m=7Pwzha5dBse',
    pirkle: 'https://my.matterport.com/show/?m=jzG57DhQ2fY',
  };

  const videoUrl = videoMap[videoKey];

  return (

<>

<div
  className="d-flex justify-content-center"
  data-aos="fade-up"
  style={{ marginTop: '140px' }}
>
  <h1
    className="text-center playfair heading-color font54 my-5"
    style={{ maxWidth: '1000px' }}
  >
    Video Tour
  </h1>
</div>




      <div style={{ textAlign: 'center', padding: '2rem', height: '100vh' }}>
      {videoUrl ? (
        <iframe
        style={{ width: '80%', height: '80%' }}
          src={videoUrl}
          frameBorder="0"
          allowFullScreen
          allow="autoplay; fullscreen; web-share; xr-spatial-tracking;"
          title="Video Tour"
        ></iframe>
      ) : (
        <p>No video found for this route.</p>
      )}
    </div>



</>

 
  );
};

export default VideoTour;
